import { useEffect, useState } from "react";
import { LiaSearchPlusSolid } from "react-icons/lia";
import { MdClose, MdModeEdit } from "react-icons/md";
import { qc } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Pagination from "../../common/Pagination";
import Button from "../../common/Button";
import { IoIosSave } from "react-icons/io";
import { AiOutlineCheck } from "react-icons/ai";

const QC = () => {
  const userId = sessionStorage.getItem("userId");
  const [searchQuery, setSearchQuery] = useState("");
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isQcData, setIsQcData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const pageSize = 10;
  const [editingRow, setEditingRow] = useState(null);
  const [backupRow, setBackupRow] = useState(null);
  const getQcId = (r) => toInt(r.qC_Id ?? r.QC_Id ?? 0);
  const isRowEditable = (r, idx) => getQcId(r) === 0 || editingRow === idx;

  const normalizeRow = (r) => ({
    ...r,
    qc_Pcs: r.qc_Pcs ?? "",
    rejected_Pcs: r.rejected_Pcs ?? "",
    approved_Pcs: r.approved_Pcs ?? "",
    first_Piece: r.first_Piece ?? "",
    first_Weight: r.first_Weight ?? "",
    second_Piece: r.second_Piece ?? "",
    second_Weight: r.second_Weight ?? "",
    // approved_Weight: r.approved_Weight ?? "",
    remark: r.remark ?? r.remarks ?? "",
  });
  const handleEdit = (rowIndex) => {
    setBackupRow(JSON.parse(JSON.stringify(isQcData[rowIndex])));
    setEditingRow(rowIndex);
  };
  const fetchQcData = async () => {
    setLoading(true);
    try {
      const res = await qc.getAllQC(currentPage, pageSize);
      const rows = (res.data || []).map(normalizeRow);
      setIsQcData(rows);
      setFilteredData(rows);
      setTotalRecords(res.totalCount || rows.length || 0);
    } catch {
      notify("Error fetching QC data", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchQcData();
  }, [currentPage]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(isQcData);
    } else {
      const filtered = isQcData.filter((d) =>
        d.status_Name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [searchQuery, isQcData]);

  const toInt = (v) =>
    v === "" || v === null || v === undefined ? 0 : parseInt(v, 10) || 0;
  const toFloat = (v) =>
    v === "" || v === null || v === undefined ? 0 : parseFloat(v) || 0;

  const handleSubmit = async (rowIndex) => {
    try {
      const row = isQcData[rowIndex];
      const payload = {
        qC_Id: toInt(row.qC_Id ?? row.QC_Id ?? 0),
        batch_Id: row.batch_Id ?? "",
        casting_No: row.casting_No ?? "",
        order_No: row.order_No,
        die_Id: row.die_Id ?? "",
        produced_Pcs: toInt(row.produced_Pcs),
        qc_Pcs: toInt(row.qc_Pcs),
        rejected_Pcs: toInt(row.rejected_Pcs),
        reject_Reason: row.reject_Reason,
        approved_Pcs: toInt(row.approved_Pcs),
        first_Piece: toInt(row.first_Piece),
        first_Weight: toFloat(row.first_Weight),
        second_Piece: toInt(row.second_Piece),
        second_Weight: toFloat(row.second_Weight),
        // approved_Weight: toFloat(row.approved_Weight),
        remark: row.remark ?? row.remarks ?? "",
        created_By: toInt(userId) || 1,
      };

      await qc.saveOrUpdate(payload);
      notify("Saved successfully", "success");
      fetchQcData();
      setIsEditing(false);
      setEditingRow(null);
      setBackupRow(null);
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to submit row";
      notify(msg, "error");
      setErrorMessage("Submission failed");
      setErrorSubMessage(msg);
      setErrorModalOpen(true);
    }
  };
  const handleMarkDone = async (rowIndex) => {
    try {
      const row = isQcData[rowIndex];
      const payload = {
        batch_Id: row.batch_Id,
        casting_No: row.casting_No,
        die_Id: row.die_Id,
        LastPCSWeight: row.second_Weight / row.second_Piece,
        created_By: 1,
      };

      await handleSubmit(rowIndex);
      if (row.produced_Pcs === row.approved_Pcs + row.rejected_Pcs) {
        await qc.MarkQCDone(payload);
        fetchQcData();
        notify("Production marked as done successfully", "success");
      } else {
        notify(
          "approved_Pcs and produced_Pcs must match to mark done",
          "error"
        );
      }
    } catch (error) {
      notify("Failed to mark production as done", "error");
    }
  };
  const handleRowChange = (rowIndex, field, raw) => {
    setIsQcData((prev) => {
      const next = [...prev];
      const row = { ...next[rowIndex] };

      row[field] = raw;
      const qc_Pcs = toInt(field === "qc_Pcs" ? raw : row.qc_Pcs);
      const rejected_Pcs = toInt(
        field === "rejected_Pcs" ? raw : row.rejected_Pcs
      );
      const first_Piece = toInt(
        field === "first_Piece" ? raw : row.first_Piece
      );
      const second_Piece = toInt(
        field === "second_Piece" ? raw : row.second_Piece
      );
      const first_Weight = toFloat(
        field === "first_Weight" ? raw : row.first_Weight
      );
      const second_Weight = toFloat(
        field === "second_Weight" ? raw : row.second_Weight
      );
      const approvedFromCalc = Math.max(qc_Pcs - rejected_Pcs, 0);
      row.approved_Pcs = String(approvedFromCalc);
      const totalPcs = first_Piece + second_Piece;
      const totalWt = first_Weight + second_Weight;
      // row.approved_Weight = totalPcs > 0 ? (totalWt / totalPcs).toFixed(3) : "";

      next[rowIndex] = row;
      return next;
    });
  };
  const inputCls =
    "w-full text-right rounded border border-slate-300 px-2 py-1 focus:ring-1 focus:ring-indigo-500";

  const renderCell = (
    row,
    rowIndex,
    field,
    { type = "text", step, alignRight = true } = {}
  ) => {
    const editable = isRowEditable(row, rowIndex);
    if (editable) {
      return (
        <input
          type={type}
          step={step}
          value={row[field] ?? ""}
          onChange={(e) => handleRowChange(rowIndex, field, e.target.value)}
          className={`${inputCls} ${alignRight ? "text-right " : ""}`}
          placeholder="0"
        />
      );
    }
    return (
      <div className={`px-2 py-1 ${alignRight ? "text-right" : ""}`}>
        {row[field] ?? "-"}
      </div>
    );
  };

  return (
    <>
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5 mt-10 ">
        <div className="flex flex-wrap justify-between items-center gap-4 mb-4">
          <div className="relative w-full sm:w-1/2 lg:w-1/3">
            <input
              type="text"
              className="w-full bg-gray-100 border border-gray-3 py-2 pl-10 pr-10 rounded-md focus:ring-1 focus:ring-primary focus:border-primary outline-none"
              placeholder="Search ..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Button
              icon={LiaSearchPlusSolid}
              iconSize="w-5 h-5"
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary"
            ></Button>
            {searchQuery && (
              <Button
                icon={MdClose}
                onClick={() => setSearchQuery("")}
                iconSize="w-5 h-5"
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-danger"
              ></Button>
            )}
          </div>
        </div>
        <div className="overflow-x-auto border border-slate-300 rounded-md">
          <table className="min-w-[1200px] w-full text-[13px]">
            <colgroup>
              <col className="w-10" />
              <col className="w-6" />
              <col className="w-40" />
              <col className="w-40" />
              <col className="w-60" />
              <col className="w-28" />
              <col className="w-28" />
              <col className="w-28" />
              <col className="w-28" />
              <col className="w-28" />
              <col className="w-32" />
              <col className="w-28" />
              <col className="w-32" />
              <col className="w-[280px]" />
              <col className="w-[280px]" />
              <col className="w-24" />
            </colgroup>

            <thead className="bg-slate-50 text-slate-700 sticky top-0 z-10">
              <tr className="text-center text-[12px] font-medium">
                <th className="border border-slate-200 p-1"></th>
                <th className="border border-slate-200 p-1">So No</th>
                <th className="border border-slate-200 p-1">Batch No</th>
                <th className="border border-slate-200 p-1">Casting No</th>
                <th className="border border-slate-200 p-1">Die No</th>
                <th className="border border-slate-200 p-1">Produced Pcs</th>
                <th className="border border-slate-200 p-1">Qc Pcs</th>
                <th className="border border-slate-200 p-1">Rejected Pcs</th>
                <th className="border border-slate-200 p-1">Approved Pcs</th>
                <th className="border border-slate-200 p-1">First Pcs</th>
                <th className="border border-slate-200 p-1">
                  First Pcs Weight
                </th>
                <th className="border border-slate-200 p-1">Second Pcs</th>
                <th className="border border-slate-200 p-1">
                  Second Pcs Weight
                </th>
                <th className="border border-slate-200 p-1">Rejected Reason</th>
                <th className="border border-slate-200 p-1">Remark</th>
                <th className="border border-slate-200 p-1">Actions</th>
              </tr>
            </thead>

            <tbody>
              {isQcData.map((row, index) => (
                <tr key={index} className="hover:bg-slate-50">
                  <td className="border border-slate-200 p-1 text-center align-middle">
                    <input type="checkbox" className="h-4 w-4" />
                  </td>
                  <td className="border border-slate-200 p-1 align-middle text-slate-800">
                    {row.so_No}
                  </td>
                  <td className="border border-slate-200 p-1">
                    <input
                      value={row.batch_Id}
                      disabled
                      className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 outline-none"
                    />
                  </td>
                  <td className="border border-slate-200 p-1">
                    <input
                      value={row.casting_No}
                      disabled
                      className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 outline-none"
                    />
                  </td>
                  <td className="border border-slate-200 p-1">
                    <input
                      value={row.dieNumber}
                      disabled
                      className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 outline-none"
                    />
                  </td>

                  <td className="border border-slate-200 p-1">
                    <input
                      type="number"
                      value={row.produced_Pcs}
                      disabled
                      className="w-full bg-slate-100 text-right rounded px-2 py-1 outline-none"
                    />
                  </td>

                  <td className="border border-slate-200 p-1">
                    {renderCell(row, index, "qc_Pcs", { type: "number" })}
                  </td>

                  <td className="border border-slate-200 p-1">
                    {renderCell(row, index, "rejected_Pcs", { type: "number" })}
                  </td>

                  <td className="border border-slate-200 p-1">
                    {renderCell(row, index, "approved_Pcs", { type: "number" })}
                  </td>

                  <td className="border border-slate-200 p-1">
                    {renderCell(row, index, "first_Piece", { type: "number" })}
                  </td>

                  <td className="border border-slate-200 p-1">
                    {renderCell(row, index, "first_Weight", {
                      type: "number",
                      step: "0.001",
                    })}
                  </td>

                  <td className="border border-slate-200 p-1">
                    {renderCell(row, index, "second_Piece", { type: "number" })}
                  </td>

                  <td className="border border-slate-200 p-1">
                    {renderCell(row, index, "second_Weight", {
                      type: "number",
                      step: "0.001",
                    })}
                  </td>

                  <td className="border border-slate-200 p-1">
                    {renderCell(row, index, "reject_Reason", {
                      alignRight: false,
                    })}
                  </td>

                  <td className="border border-slate-200 p-1">
                    {renderCell(row, index, "remark", { alignRight: false })}
                  </td>

                  <td className="border border-slate-200 p-1 text-center">
                    <div className="inline-flex gap-1">
                      <button
                        type="button"
                        onClick={() => handleEdit(index)}
                        className="px-2 py-1 rounded text-primary "
                        title="Edit"
                      >
                        <MdModeEdit />
                      </button>
                      <button
                        type="button"
                        onClick={() => handleSubmit(index)}
                        className="px-2 py-1 rounded text-primary "
                        title="Save"
                      >
                        <IoIosSave />
                      </button>
                      <button
                        type="button"
                        onClick={() => handleMarkDone(index)}
                        className="px-2 py-1 rounded text-primary "
                        title="Mark Done"
                      >
                        <AiOutlineCheck />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex justify-center items-center mt-4">
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil(totalRecords / pageSize)}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>
    </>
  );
};

export default QC;
